export type DeviceType = 'ios' | 'android' | 'unknown';

export function getDeviceType(): DeviceType {
  const ua = navigator.userAgent.toLowerCase();

  if (/iphone|ipad|ipod/.test(ua)) {
    return 'ios';
  }

  if (/android/.test(ua)) {
    return 'android';
  }

  return 'unknown';
}
